import pdpConfig from "./rbmc.pdp-configurator-field";
import pdpPlayerPersonalization from "./rbmc.pdp-player-personalization";
import productDetails from "./rbmc.pdp";
import pdpBlacklist from './rbmc.pdp-blacklist';
import pdpAddToCart from './rbmc.pdp-add-to-cart';
import pdpSlider from './rbmc.pdp-slider';

const pdpCustomPersonalization = {
    savePersonalization: undefined,
    persName:            undefined,
    persNumber:          undefined,

    bindEvents() {
        let allowedFlockName = new RegExp("^[A-ZÄÖÜß ]*$");
        // if name or number is changed/focused out , check to enable save button
        pdpConfig.personalizationPanel.on('change input blur',
                '#pdp__personalization-name, #pdp__personalization-number', function () {

                    let name          = pdpCustomPersonalization.formatCustomName(pdpCustomPersonalization.persName.val()),
                        number        = pdpCustomPersonalization.persNumber.val(),
                        invalidName   = pdpBlacklist.isBlacklisted(name) || !allowedFlockName.test(name),
                        invalidNumber = pdpCustomPersonalization.invalidNumber(number);
                    pdpCustomPersonalization.persName.val(name);

                    //prevent entering letters
                    pdpCustomPersonalization.persNumber.val(number.replace(/[^\d]+/g, ''));

                    //remove leading 0 and allow only one 0
                    if (number.length >= 2) {
                        pdpCustomPersonalization.persNumber.val(number.replace(/^0/, ''));
                    }

                    if (invalidName) {
                        pdpCustomPersonalization.persName.tooltip("show");
                    } else {
                        pdpCustomPersonalization.persName.tooltip("hide");
                    }

                    if (invalidNumber && number !== "") {
                        pdpCustomPersonalization.persNumber.tooltip("show");
                    } else {
                        pdpCustomPersonalization.persNumber.tooltip("hide");
                    }

                    if (invalidName || invalidNumber || name === "" || number === "") {
                        pdpConfig.savePersonalization.prop("disabled", true);
                    } else {
                        pdpConfig.savePersonalization.prop("disabled", false);

                    }
                });

        //save button action
        pdpConfig.savePersonalization.on('click', function () {
            pdpCustomPersonalization.savePersonalizationFn(false);
        });

        pdpCustomPersonalization.formatCustomName = function (customName) {
            if (typeof customName === "string") {
                const customNameUppercase = [],
                      regExp              = new RegExp("(\ß)[^ ]*");
                $.each([...customName], (i, nameLetter) => {
                    !regExp.test(nameLetter) ?
                            customNameUppercase.push(nameLetter.toUpperCase()) :
                            customNameUppercase.push(nameLetter);
                });
                return customNameUppercase.join('');
            }
        };

        pdpConfig.personalizationPanel.on('click', '.pdp__icon-back', function () {
            //check if first time changed and show popup
            if (pdpConfig.firstTimePersonalized) {
                if (!(pdpCustomPersonalization.persNumber.val() === "" && pdpCustomPersonalization.persName.val() === "")) {
                    pdpConfig.personalizationPanel.find('.pdp__back').tooltip('show');
                    let customPersonalization = $('#pdp__tooltip-custom-personalization');

                    customPersonalization.on('click', '.pdp__tooltip-confirm', function () {
                        pdpConfig.personalizationPanel.find('.pdp__back').tooltip('hide');
                        pdpConfig.firstTimePersonalized = false;
                        pdpCustomPersonalization.savePersonalization.not(':disabled').click();
                        pdpCustomPersonalization.persName.tooltip("hide");
                        pdpCustomPersonalization.persNumber.tooltip("hide");
                        pdpConfig.personalizationPanel.change();
                    });

                    customPersonalization.on('click', '.pdp__tooltip-cancel', function () {
                        pdpConfig.personalizationPanel.find('.pdp__back').tooltip('hide');
                        pdpConfig.firstTimePersonalized = false;
                        pdpConfig.closePersonalizationPanel();
                    });
                } else {
                    pdpConfig.closePersonalizationPanel();
                }
            } else {
                pdpConfig.closePersonalizationPanel();
            }
        });

        // reset custom personalization form to defaults
        let resetToDefaults = $("#pdp__reset-custom-personalization");
        resetToDefaults.on('click', function () {
            pdpConfig.personalizationPanel.find(".form-control").val("").trigger('change');
        });

    },

    savePersonalizationFn(urlFlock = false, urlFlockName, urlFlockNumber) {
        if (pdpConfig.playerChosenFlag) {
            pdpConfig.savePersonalization.tooltip("show");
            const savePersonalizationTooltip = $('#pdp__tooltip-save-personalization');

            savePersonalizationTooltip.on('click', '.pdp__tooltip-confirm', function () {
                pdpConfig.savePersonalization.tooltip('hide');
                pdpPlayerPersonalization.resetPdpPlayerSelectChoice();
                pdpCustomPersonalization.personalizationNameNumber(
                        pdpCustomPersonalization.persName,
                        pdpCustomPersonalization.persNumber
                );
                pdpCustomPersonalization.persName.tooltip("hide");
                pdpCustomPersonalization.persNumber.tooltip("hide");
                pdpConfig.closePersonalizationPanel();
                productDetails.menuOpened = false;
                pdpSlider.goToPersonalizedSlide();
            });

            savePersonalizationTooltip.on('click', '.pdp__tooltip-cancel', function () {
                pdpCustomPersonalization.persName.tooltip("hide");
                pdpCustomPersonalization.persNumber.tooltip("hide");
                pdpConfig.savePersonalization.tooltip('hide');
            });

        } else {
            pdpCustomPersonalization.personalizationNameNumber(
                    urlFlock ? urlFlockName : pdpCustomPersonalization.persName,
                    urlFlock ? urlFlockNumber : pdpCustomPersonalization.persNumber
            );
            pdpCustomPersonalization.persName.tooltip("hide");
            pdpCustomPersonalization.persNumber.tooltip("hide");
            pdpConfig.configuratorWrapper.removeClass('d-none');
            productDetails.menuOpened = false;
        }
        pdpSlider.goToPersonalizedSlide();
    },

    invalidNumber(number) {
        try {
            let numberToCheck = parseInt(number),
                min           = pdpCustomPersonalization.persNumber.attr('min'),
                max           = pdpCustomPersonalization.persNumber.attr('max');
            return numberToCheck < min || numberToCheck > max;
        } catch (e) {
            return false;
        }
    },

    resetNameAndNumberChoice(event) {
        if (event !== undefined) {
            event.stopImmediatePropagation();
        }
        pdpConfig.personalizationControl.find('.pdp__configurator-inner-text').html(
                pdpConfig.personalizationControl
                         .find('.pdp__configurator-inner-text').data('default')
        );
        pdpConfig.restoreOriginalImageSrc();
        pdpConfig.personalizationPanel.find(".form-control").val("");
        pdpConfig.savePersonalization.prop("disabled", true);
        pdpConfig.personalizationControl.find('.pdp__icon-reset').addClass('d-none');
        pdpConfig.customNameFlag = false;
        pdpAddToCart.setPersonalization('', '', '');
    },

    personalizationNameNumber(persName, persNumber) {
        pdpConfig.personNameNumber
                 .parents('#pdp__personalization-control')
                 .find(".pdp__icon-reset")
                 .removeClass("d-none");
        pdpConfig.personNameNumber.text(
                `${pdpCustomPersonalization.formatCustomName(persName.val())} / ${persNumber.val()}`
        );

        if(productDetails.cdnUrl){
            pdpConfig.setCustomizedImageUrl(
                    [pdpConfig.personalizeImage, pdpConfig.personalizeMobileImage],
                    productDetails.cdnUrl,
                    persName.val(),
                    persNumber.val()
            );
        }

        pdpConfig.closePersonalizationPanel(true);
        pdpConfig.customNameFlag = true;

        pdpAddToCart.setPersonalization(persName.val(), persNumber.val(), 'INDIVIDUAL');
    },

    cacheSelectors() {
        pdpCustomPersonalization.savePersonalization = $('#pdp__save-personalization');
        pdpCustomPersonalization.persName            = $('#pdp__personalization-name');
        pdpCustomPersonalization.persNumber          = $('#pdp__personalization-number');
    },

    init() {
        pdpCustomPersonalization.cacheSelectors();
        pdpCustomPersonalization.bindEvents();
    }
};

export default pdpCustomPersonalization;
